<!-- Button -->
<button
    mat-icon-button
    class="pf-header-icon-btn"
    [matMenuTriggerFor]="userActions"
    [attr.aria-label]="'common.openUserMenu' | transloco"
>
    <span class="relative flex h-7 w-7 shrink-0 items-center justify-center">
        @if (showAvatar && user.avatar) {
            <!-- Material sets .mat-mdc-icon-button img { height: auto !important },
                 which beats h-7 — keep the img inside a clipped fixed-size box. -->
            <span class="block h-7 w-7 shrink-0 overflow-hidden rounded-full">
                <img
                    class="!h-full !w-full object-cover"
                    [src]="user.avatar | absoluteMediaUrl"
                    [alt]="'common.userAvatar' | transloco"
                />
            </span>
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon
                class="!icon-size-7"
                [svgIcon]="'heroicons_outline:user-circle'"
            ></mat-icon>
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 shrink-0 rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
                'bg-teal-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-zinc-400': user.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <ng-container *transloco="let t">
        <button mat-menu-item>
            <span class="flex flex-col leading-none">
                <span>{{ t('signIn.signedInAs') }}</span>
                <span class="mt-1.5 text-md font-medium">{{
                    user.email || user.first_name || user.username
                }}</span>
            </span>
        </button>
        <div class="divider my-2 border-t"></div>

        @if (canRequestStudio) {
            <a mat-menu-item routerLink="/org-registration/request">
                <mat-icon
                    [svgIcon]="'heroicons_outline:building-storefront'"
                ></mat-icon>
                <span>{{ t('orgRegistration.requestStudioMenu') }}</span>
            </a>
            <div class="divider my-2 border-t"></div>
        }

        @if (canAccessAdminPortal) {
            <!-- Same tab: one PhotoFlow system, not a separate "admin product" window -->
            <a mat-menu-item [href]="saPortalUrl">
                <mat-icon
                    [svgIcon]="'heroicons_outline:shield-check'"
                ></mat-icon>
                <span>{{ t('nav.platformAdmin') }}</span>
            </a>
            <div class="divider my-2 border-t"></div>
        }

        <a mat-menu-item routerLink="/me">
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span>{{ t('nav.myAccount') || 'My account' }}</span>
        </a>
        <a mat-menu-item [href]="iamPortalUrl">
            <mat-icon [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
            <!-- #3783: same destination as the sidebar's account entry
                 (IAM /me) — same label, not a second name for one page. -->
            <span>{{ t('nav.fallback.securitySessions') }}</span>
        </a>
        <div class="divider my-2 border-t"></div>

        <a mat-menu-item href="/sign-out">
            <mat-icon
                [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
            ></mat-icon>
            <span>{{ t('signIn.signOut') }}</span>
        </a>
    </ng-container>
</mat-menu>
